const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, any> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, name] = match;
    const module = modules[path] as { default?: Record<string, any> };
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    if (module.default) {
      messages[lang].translation[name] = module.default;
    }
  }
});

export default messages; 